module.exports = {
	"productName": "Renault Mobility",
	"metaTitle": "Renault Mobility By Mobilize",
	"brandId": "be82aeef-aa02-4664-a415-5e252fda16cd",
	"metaDescription": "Beyond Automotive",
	"font": {
		"regular": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/Graphie-Book.woff",
		"medium": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/Graphie-SemiBold.woff",
		"bold": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/Graphie-Bold.woff"
	},
	"preHeaderRessource": {
		"fr": "En octobre, <strong>Renault Mobility</strong> deviendra <strong>Mobilize share</strong>",
		"en": "In October, <strong>Renault Mobility</strong> will become <strong>Mobilize share</strong>",
		"cs": "V říjnu se z <strong> Renault Mobility </strong> stane <strong> Mobilize share </strong>",
		"da": "I oktober bliver <strong> Renault Mobility </strong> <strong> Mobilize-aktie </strong>",
		"de": "Im Oktober wird <strong> Renault Mobility </strong> zu <strong> Mobilize share </strong>",
		"es": "En octubre, <strong> Renault Mobility </strong> se convertirá en <strong> Mobilize share </strong>",
		"it": "A ottobre, <strong> Renault Mobility </strong> diventerà <strong> Mobilize share </strong>",
		"nl": "In oktober wordt <strong> Renault Mobility </strong> <strong> Mobilize share </strong>",
		"pl": "W październiku <strong> Renault Mobility </strong> stanie się <strong> Udziałem Mobilize </strong>",
		"pt_BR": "Em outubro, a <strong> Mobilidade Renault </strong> se tornará a <strong> participação do Mobilize </strong>",
		"pt": "Em outubro, a <strong> Mobilidade Renault </strong> se tornará a <strong> participação do Mobilize </strong>",
		"sk": "V októbri sa z <strong> Renault Mobility </strong> stane <strong> Mobilize share </strong>",
		"sv": "I oktober blir <strong> Renault Mobility </strong> <strong> Mobilize-aktie </strong>"
	},
	"howItWorksShowNumber": false,
	"howItWorks": [
		{
			"image": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/tuto/1.png",
			"text": "<strong>Téléchargez l’application</strong> sur l’App Store ou Google Play.",
			"i18n": {
				"en": "<strong>Download application</strong> from the App Store or Google Play.",
				"fr": "<strong>Téléchargez l’application</strong> sur l’App Store ou Google Play.",
				"it": "<strong>Scarica l'applicazione</strong> da App Store o Google Play.",
				"es": "<strong>Descargue la aplicación</strong> desde App Store o Google Play."
			}
		},
		{
			"image": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/tuto/2.png",
			"text": "Lancez l’application et <strong>inscrivez-vous</strong> en remplissant le formulaire.",
			"i18n": {
				"en": "Launch application and <strong>register</strong> by filling out the form.",
				"fr": "Lancez l’application et <strong>inscrivez-vous</strong> en remplissant le formulaire.",
				"it": "Avvia l'applicazione e <strong>registrati</strong> compilando il modulo.",
				"es": "Inicie la aplicación y <strong>regístrese</strong> completando el formulario."
			}
		},
		{
			"image": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/tuto/3.png",
			"text": "Photographiez votre <strong>permis de conduire</strong>, votre <strong>carte d’identité</strong> et <strong>prenez-vous en photo</strong> avec votre carte d’identité à côté de votre visage, enregistrez le tout dans l’application !",
			"i18n": {
				"en": "Take a picture of your <strong>driver's license</strong>, your <strong>identity card</strong> and <strong>take a picture of yourself</strong> with your ID card next to your face, save it all in the app!",
				"fr": "Photographiez votre <strong>permis de conduire</strong>, votre <strong>carte d’identité</strong> et <strong>prenez-vous en photo</strong> avec votre carte d’identité à côté de votre visage, enregistrez le tout dans l’application !",
				"it": "Scatta una foto della tua <strong>patente di guida</strong> e <strong>carta d'identità</strong> e <strong>scatta una foto del tuo viso</strong> con accanto la carta d'identità, quindi salva tutto nell'app!",
				"es": "Saque una foto a su <strong>permiso de conducir</strong>, a su <strong>documento de identidad</strong> y <strong>sáquese una foto a usted mismo</strong> con su documento de identidad al lado de la cara, ¡guárdelo todo en la aplicación!"
			}
		},
		{
			"image": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/tuto/4.png",
			"text": "<strong>Enregistrez votre carte bancaire</strong> pour gérer le règlement de vos locations.",
			"i18n": {
				"en": "<strong>Register your bank card</strong> to manage the payment of your rentals.",
				"fr": "<strong>Enregistrez votre carte bancaire</strong> pour gérer le règlement de vos locations.",
				"it": "<strong>Registra la tua carta di credito</strong> per gestire il pagamento dei noleggi.",
				"es": "<strong>Registre su tarjeta bancaria</strong> para administrar el pago de sus alquileres."
			}
		},
		{
			"image": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/tuto/5.png",
			"text": "<strong>Validez votre adresse courrier</strong> en cliquant sur le lien qui vous est envoyé. <strong>Vérifiez vos pourriels.</strong>",
			"i18n": {
				"en": "<strong>Validate your email address</strong> by clicking on the link sent to you. <strong>Check your SPAM folders.</strong>",
				"fr": "<strong>Validez votre adresse courrier</strong> en cliquant sur le lien qui vous est envoyé. <strong>Vérifiez vos pourriels.</strong>",
				"it": "<strong>Verifica il tuo indirizzo email</strong> cliccando su link che ti abbiamo inviato. <strong>Controlla anche nella cartella SPAM</strong>.",
				"es": "<strong>Valide su dirección de correo electrónico</strong> haciendo clic en el enlace que se le envió. <strong>Revise sus carpetas de correo no deseado</strong>."
			}
		},
		{
			"image": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/tuto/6.png",
			"text": "Une fois votre inscription validée, <strong>réservez votre véhicule</strong> sur notre application ou sur notre site Internet. Le jour de votre réservation, <strong>votre smartphone est votre clé !</strong>",
			"i18n": {
				"en": "Once your registration is validated, <strong>reserve your vehicle</strong> on our application or on our website. On the day of your reservation, <strong>your smartphone is your key!</strong>",
				"fr": "Une fois votre inscription validée, <strong>réservez votre véhicule</strong> sur notre application ou sur notre site Internet. Le jour de votre réservation, <strong>votre smartphone est votre clé !</strong>",
				"it": "Una volta verificata la registrazione, <strong>prenota pure il tuo veicolo</strong> sulla nostra app o sul nostro sito. Il giorno della prenotazione, <strong> potrai usare il telefono come chiave!</strong>",
				"es": "Una vez que su registro esté validado, <strong>reserve su vehículo</strong> en nuestra aplicación o en nuestro sitio web. El día de su reserva, <strong>¡su smartphone será su clave!</strong>"
			}
		}
	],
	"mapCountries": {
		"FR": {
			"companyId": "58107ebe-dc4c-403f-a54e-25271fd43da9",
			"countryName": "France",
			"iconUrl": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/images/fr.svg",
			"infosUrl": "https://mobility.renault.fr/libre-service"
		},
		"IT": {
			"companyId": "bf5fee16-55d1-433f-9207-609a19f8e666",
			"countryName": "Italia",
			"iconUrl": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/images/it.svg"
		}
	},
	"keycloak": {
		"enabled": true,
		"useBrandConfig": true,
		"clientId": "rrent_web",
		"realm": "renault-mobility",
		"identityProvider": "google",
		"superCompanyId": "bf5fee16-55d1-433f-9207-609a19f8e666"
	},
	"apiBaseUrl": "https://gwweb-valid-rrent.tech.rcimobility.com/api",
	"appStoreLink": "https://itunes.apple.com/fr/app/renault-mobility/id1189566096?mt=8",
	"playStoreLink": "https://play.google.com/store/apps/details?id=com.rcimobility.renaultmobility.b2c",
	"mobileBannerImage": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/mobileBanner.png",
	"favicon": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/favicon.ico",
	"productTagLine": "Solutions de mobilité",
	"productTagLinei18n": {
		"fr": "Au-delà de l'automobile",
		"en": "Beyond Automotive",
		"it": "Oltre l'automotive",
		"es": "Más allá de la automoción",
		"pt": "Beyond Automotive",
		"de": "Beyond Automotive",
		"da": "Beyond Automotive",
		"nl": "Beyond Automotive",
		"pl": "Beyond Automotive",
		"sv": "Beyond Automotive",
		"cs": "Beyond Automotive",
		"pt_BR": "Beyond Automotive",
		"sl": "Beyond Automotive"
	},
	"restrictedAccess": false,
	"showServicesTabs": true,
	"servicesIcons": {
		"corporate": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/icons/ic_service_corporate_carsharing_mobilize.svg",
		"private": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/icons/ic_service_car_rental_mobilize.svg",
		"vr": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/icons/ic_service_replacement_vehicle_mobilize.svg"
	},
	"gtmId": "GTM-KML36FP",
	"footerData": {
		"aboutUrl": "https://group.renault.com",
		"linkedinUrl": "https://fr.linkedin.com/company/renault",
		"twitterUrl": "https://twitter.com/renault_fr",
		"personalDataUrl": "https://www.mobilize.com/en/renault-group-and-your-personal-data",
		"legalInformationUrl": "https://www.mobilize.com/en/legal-information",
		"hotline": [
			{
				"name": "Hotline",
				"countryCode": "+33",
				"nationalNumber": "08 05 08 02 17"
			}
		]
	},
	"theme": {
		"colors": {
			"primary": "#000",
			"secondary": "#f45000"
		},
		"buttons": {
			"primary": {
				"border-radius": "1px",
				"color": "#FFF",
				"background-color": "#000",
				"text-transform": "lowercase"
			},
			"secondary": {
				"color": "#000",
				"background-color": "#FFF",
				"border-radius": "1px",
				"text-transform": "lowercase",
				"border": "2px solid #000"
			}
		},
		"hr": {
			"height": "1px",
			"border": "0",
			"background-color": "#D9D9D9",
			"margin": "20px 0 !important"
		},
		"headerHeight": "100px",
		"datetimePicker": {
			"radius": 0,
			"bgcolor": "#f45000"
		},
		"background": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/background.png",
		"logo": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/logo-white.svg",
		"logoLogin": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/icon.svg",
		"logoMobile": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/logo-dark.svg",
		"icons": {
			"profile": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/icons/ic_member_avatar_mobilize.svg",
			"credential": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/icons/ic_member_account_credentials_mobilize.svg",
			"avatarMen": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/icons/ic_personal_info_male_mobilize.svg",
			"avatarWomen": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/icons/ic_personal_info_female_mobilize.svg",
			"drivingLicence": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/icons/ic_driving_licence_mobilize.svg",
			"paymentCard": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/icons/ic_card_general_mobilize.svg",
			"notificationsEmails": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/icons/ic_notification_bell_mobilize.svg",
			"additionalInfos": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/icons/ic_additional_information_mobilize.svg",
			"profilLanguage": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/icons/ic_profile_language_mobilize.svg",
			"identityDocument": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/icons/ic_identity_document_mobilize.svg",
			"selfie": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/icons/ic_selfie_mobilize.svg",
			"upcomingBookings": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/icons/ic_placeholder_upcoming_bookings_mobilize.svg",
			"vehiclePlaceholder": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/icons/ic_placeholder_upcoming_bookings_mobilize.svg",
			"pastBookings": "https://rcimob-assets.s3-eu-west-1.amazonaws.com/web-app/mobilize/resources/icons/ic_placeholder_past_bookings_mobilize.svg"
		}
	},
	"language": [
		"en",
		"fr",
		"it",
		"es"
	],
	"bookingTimeUnit": 45,
	"contract": {
		"shuttle": false,
		"rideSharing": true,
		"privateCarSharing": true,
		"businessCarSharing": false,
		"privateFreeFloating": false,
		"businessFreeFloating": false,
		"interfaceConfig": {
			"oneWayDisplay": true,
			"returnTripDisplay": true,
			"replacementVehicleDisplay": false
		},
		"preBooking": true,
		"flexibleSearch": false
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/mocks/defaultBrand.json
 ** module id = 431
 ** module chunks = 0
 **/